module.exports = __webpack_public_path__ + "a.no2.675ba01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/a.no2.jpg
// module id = fP7k
// module chunks = 0